<template>
  <section class="navbar__menu">
    <v-menu top right min-width="200px" max-width="300" nudd>
      <template v-slot:activator="{ on, attrs }">
        <section class="navbar__menu__avatar" v-bind="attrs" v-on="on">
          <div class="navbar__menu__avatar__photo">
            <v-icon size="32px"> mdi-account-circle-outline </v-icon>
          </div>

          <div class="navbar__menu__avatar__name">
            <span>
              {{ salutations }},
              <span class="navbar__menu__avatar__name__captalize">
                {{ connectedUser.firstName }}!
              </span>
            </span>

            <small>{{ connectedUser.unityName }}</small>
          </div>
        </section>
      </template>

      <NavbarMenuOptions :connectedUser="connectedUser" />
    </v-menu>
  </section>
</template>

<script>
import NavbarMenuOptions from "./NavbarMenuOptions.vue";
import { getConnectedUser } from "@/utils/localStorage";

export default {
  name: "NavbarMenu",

  props: {
    resource: {
      type: Object,
    },
  },

  data: () => ({
    connectedUser: {},
  }),

  computed: {
    salutations() {
      const completeHour = new Date().toLocaleTimeString();
      const onlyHour = parseInt(completeHour.split(":")[0]);
      if (onlyHour >= 6 && onlyHour <= 18) {
        return onlyHour >= 6 && onlyHour <= 11
          ? this.$t("salutations.good_morning")
          : this.$t("salutations.good_afternoon");
      }

      return this.$t("salutations.good_night");
    },
  },

  components: { NavbarMenuOptions },

  created() {
    const connectedUser = getConnectedUser();
    this.connectedUser = {
      fullName: connectedUser.name.toLowerCase(),
      firstName: connectedUser.name.split(" ")[0].toLowerCase(),
      email: connectedUser.email,
      profileName: connectedUser.profile.toLowerCase(),
      unityName: connectedUser.unity_name,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";

.navbar__menu {
  border-radius: 10px;
  padding: 2px 6px 2px 3px;
  transition: 400ms;
  user-select: none;

  &:hover {
    transition: 400ms;

    .v-icon {
      color: $blue;
    }
  }

  .navbar__menu__avatar {
    display: flex;
    align-items: center;
    gap: 5px;
    max-width: fit-content;
    cursor: pointer;

    .navbar__menu__avatar__name {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      span {
        font-size: 12px;
        font-weight: 500;
        margin-bottom: -3px;
      }

      .navbar__menu__avatar__name__captalize {
        text-transform: capitalize;
      }

      small {
        font-size: 10px;
        max-width: 120px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.v-menu__content {
  box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px !important;
}
</style>
